module.exports = "#p{\n    color:black;\n    font-weight: 900;\n   \n}\n"